const WP_CONTENT_PREFIX = ENV == 'development' ? './' : '/wp-content/themes/crxmouse/welcome/public';
const OPTION_PAGE = "chrome-extension://jlgkpaicikihijadgifklkbpdajbkhjo/options.html";

const FIRST_PAGE = ENV == 'development' ? '../public/onboardingStart.html' : '/the-mouse-chase-1';
const SECOND_PAGE = ENV == 'development' ? '../public/onboardingMiddle.html' : '/the-mouse-chase-2';
const THIRD_PAGE = ENV == 'development' ? '../public/onboardingEnd.html' : '/the-mouse-chase-3';

const SCREENS = {
    zero: 0,
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
    fifth: 5,
    sixth: 6
};

export {WP_CONTENT_PREFIX, OPTION_PAGE, SCREENS, FIRST_PAGE, SECOND_PAGE, THIRD_PAGE};
